import { ArrowRight, X } from 'lucide-react';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'specly:builder:onboarding:v1';

const STEPS = [
  {
    title: 'Toggle features to compose your spec',
    body: 'Turn features on or off. Dependencies auto-enable; required features stay locked.',
  },
  {
    title: 'Watch the tradeoffs update live',
    body: 'Each change shows the impact — effort estimate, complexity, and decisions adjust as you go.',
  },
  {
    title: 'Export when you like what you see',
    body: 'Copy a prompt-ready spec for Claude, Cursor, or any AI builder — or save it to your dashboard.',
  },
];

export default function OnboardingTour() {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {}
  }, []);

  function dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'done');
    } catch {}
    setOpen(false);
  }

  if (!open) return null;

  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[60] bg-black/30 flex items-end sm:items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-5 relative">
        <button
          type="button"
          onClick={dismiss}
          className="absolute top-3 right-3 p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-700"
          aria-label="Skip tour"
        >
          <X className="h-4 w-4" />
        </button>
        <p className="text-xs font-semibold text-indigo-600 uppercase tracking-wide mb-2">
          Step {step + 1} of {STEPS.length}
        </p>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">
          {current.title}
        </h3>
        <p className="text-sm text-gray-600 leading-relaxed">{current.body}</p>
        <div className="mt-5 flex items-center justify-between">
          <div className="flex gap-1.5">
            {STEPS.map((_, i) => (
              <span
                key={i}
                className={`h-1.5 rounded-full transition-all ${
                  i === step ? 'w-6 bg-indigo-600' : 'w-1.5 bg-gray-200'
                }`}
              />
            ))}
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={dismiss}
              className="text-sm text-gray-500 hover:text-gray-800 px-2 py-1"
            >
              Skip
            </button>
            <button
              type="button"
              onClick={() => (isLast ? dismiss() : setStep((s) => s + 1))}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700"
            >
              {isLast ? 'Got it' : 'Next'}
              {!isLast && <ArrowRight className="h-3.5 w-3.5" />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
